/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { PAYMENT_PROVIDER_LINE_ITEM_TYPES } from '../../../config/constants';
import CheckoutEcomStoreLineItem from './CheckoutEcomStoreLineItem';
import CheckoutMerchLineItem from './CheckoutMerchLineItem';
import CheckoutRegistrationLineItem from './CheckoutRegistrationLineItem';

const CheckoutRegCartLineItem = ({ lineItem, ...rest }) =>
  lineItem.lineItemType === PAYMENT_PROVIDER_LINE_ITEM_TYPES.ecommerce.value ? (
    <CheckoutEcomStoreLineItem lineItem={lineItem} {...rest} />
  ) : lineItem.lineItemType === PAYMENT_PROVIDER_LINE_ITEM_TYPES.merch.value ? (
    <CheckoutMerchLineItem lineItem={lineItem} {...rest} />
  ) : (
    <CheckoutRegistrationLineItem lineItem={lineItem} {...rest} />
  );

CheckoutRegCartLineItem.propTypes = { lineItem: PropTypes.object };

export default CheckoutRegCartLineItem;
